const config = require("config");

(function (angular) {
  "use strict";

  angular
    .module("alk.sso")
    .service("ssoService", ["$q", "$http", "UserProvider",
      function ($q, $http, UserProvider) {

        return {
          getUsersInProduct: getUsersInProduct,
          createNewUser: createNewUser,
          updateExistingUser: updateExistingUser,
          removeUser: removeUser
        };

        function getEncodedHeader() {
          let basicAuthHeader = UserProvider.getUser().userName + ":" + UserProvider.getUser().account + ":" + UserProvider.getUser().authToken;
          return "Basic " + window.btoa(basicAuthHeader);
        }

        //Get users in the current logged in account
        function getUsersInProduct(params) {
          let userInfoRequest = {
            url: config.mapsureUrl + "admin/users",
            method: "GET",
            headers: {
              Authorization: getEncodedHeader()
            }
          };
          return $http(userInfoRequest);
        }

        function createNewUser(params) {
          return $http.post(config.mapsureUrl + "admin/users/createNewUser", {
            FirstName: params.firstName,
            LastName: params.lastName,
            Email: params.emailAddress
          }, {
            params: {
              role: params.role,
              
            },
            headers: {
              Authorization: getEncodedHeader()
            }
          });
        }

        function updateExistingUser(params) {
          return $http.post(config.mapsureUrl + "admin/users/updateUser", {
            Email: params.emailAddress,
            Role: params.role,
            UserState: (params.userState) ? params.userState : 1
          }, {
            headers: {
              Authorization: getEncodedHeader()
            }
          });
        }

        //Removes a user from account/product association (does not hard-delete them or remove from other account/product association)
        function removeUser(params) {
          return $http.post(config.mapsureUrl + "admin/users/removeUser", {
            Email: params.emailAddress,
            Role: params.role,
            UserState: (params.userState) ? params.userState : 1
          }, {
            headers: {
              Authorization: getEncodedHeader()
            }
          });
        }

      }
    ]);
})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-sso/sso.service.js